import { useEffect, useState } from "react";

export type TStripeData = {
	stripeAccountId: string;
	status: "ACTIVE" | "REQUEST";
	isCardPayment: boolean;
	isTransfer: boolean;
};

export type TStripeService = {
	stripeData: TStripeData | null;
	listeners: (() => void)[];

	addEventListener: (cb: () => void) => void;
	removeEventListener: (cb: () => void) => void;
	emitChanges: () => void;

	saveStripeData: (newStripeData: TStripeData | null) => void;
	updateStripeData: (partialStripeData: Partial<TStripeData>) => void;
	clearData: () => void;
};

export const StripeService: TStripeService = {
	stripeData: null,
	listeners: [],

	addEventListener(cb) {
		this.listeners = this.listeners.filter((listener) => listener !== cb);
		this.listeners.push(cb);
	},

	saveStripeData(newData) {
		this.stripeData = newData;
		this.emitChanges();
	},

	updateStripeData(partialNewData) {
		if (this.stripeData) {
			this.stripeData = { ...this.stripeData, ...partialNewData };
		}
		this.emitChanges();
	},

	clearData() {
		this.stripeData = null;
		this.emitChanges();
	},

	emitChanges() {
		for (const listener of this.listeners) {
			listener();
		}
	},

	removeEventListener(cb) {
		this.listeners = this.listeners.filter((listener) => listener !== cb);
	},
};

export function useStripe() {
	const [stripeData, setStripeData] = useState(StripeService.stripeData);

	useEffect(() => {
		const updateStripeData = () => {
			setStripeData(StripeService.stripeData);
		};

		StripeService.addEventListener(updateStripeData);

		return () => {
			StripeService.removeEventListener(updateStripeData);
		};
	}, []);

	return { stripeData };
}
